import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { TrackedStreamField } from "../components/PageSkeleton/TrackedStreamField";
import { SearchResults } from "../components/SearchResults";

export const Template = (props: templates.SearchResultsPageTemplate) => (
    <PageSkeleton {...props.page} isPreview={props.is_preview}>
        <TrackedStreamField
            components={{
                ...toolboxComponents,
                search_results: () => (
                    <SearchResults filters={props.page.filters} />
                ),
            }}
            value={props.page.body.value}
            tagName={React.Fragment}
        />
    </PageSkeleton>
);
